import PropTypes from 'prop-types';

export const deviationPropType = PropTypes.shape({
    code: PropTypes.string,
    fromDate: PropTypes.string,
    toDate: PropTypes.string,
});
